import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import SchoolOutlinedIcon from '@material-ui/icons/SchoolOutlined';
import LocationOnIcon from '@material-ui/icons/LocationOn';

import DescriptionIcon from '@material-ui/icons/Description';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';

import CandidatoService from '../../services/Candidato';
import EnumService from '../../services/Enum';

import Filters from '../../components/Filters/Filters';
import Boolean from '../../components/Inputs/Boolean/Boolean';
import Text from '../../components/Inputs/Text/Text';
import SelectOption from '../../components/Inputs/Select/Select';
import Categoria from '../../components/Categoria/Categoria';

import Endereco, { EnderecoFilter as EscolaEndereco } from '../Endereco/EnderecoFilter';
import DependenciaAdministrativa from '../DependenciaAdministrativa/DependenciaAdministrativaFilter';
import { EscolaFilterFields as Escola } from '../Escola/EscolaFilterFields';
import LocalProva from '../LocalProva/LocalProvaFilter';

import { download } from '../../helper/FileHelper';
import { removePagingAndSorting } from '../../helper/PaginationHelper';

export class CandidatoFilter extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            filters: {
                codigo: '',
                codigoProva: '',
                nome: '',
                nomeSoberano: '',
                email: '',
                cpf: '',
                sexo: '',
                necessidadeEspecial: '',
                sabatista: '',
                comEscolaSelecionada: '',
                status: '',
                dataInicioInscricao: '',
                dataFinalizacaoInscricao: '',
                candidaturaFinalizada: '',
                candidaturaReaberta: '',
                statusDocumento: '',
                comLocalProvaSelecionado: '',
                dataConfirmacaoLocalProva: '',
            },
            exportPlan: false,
            exportarPlanLocalProva: false,
            count: 0,
            optionsStatusCandidato: [{ value: 'INICIADO', label: 'Inscrição Incompleta' }],
            optionsSexo: [],
            optionsNecessidadesEspecial: [],
            optionsStatusDocumento: [],
            optionsLocalProva: [],
        }
    }

    // INPUTS
    handleChange = e => {
        this.setState({
            filters: { ...this.state.filters, [e.target.name]: e.target.value }
        });
    };

    // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES TIPO FORM
    setEndereco = form => this.Endereco = form;
    setDependenciaAdministrativa = form => this.DependenciaAdministrativa = form;
    setEscola = form => this.Escola = form;
    setEscolaEndereco = form => this.EscolaEndereco = form;
    setLocalProvaOriginal = form => this.LocalProvaOriginal = form;
    setLocalProvaConfirmado = form => this.LocalProvaConfirmado = form;

    // APLICAR PERSISTENCIA
    handleFilterPersistence = (filters) => {
        filters = removePagingAndSorting(filters);

        this.setState({
            filters: {
                codigo: filters.find(f => f.field === 'codigo') ? filters.find(f => f.field === 'codigo').value : "",
                codigoProva: filters.find(f => f.field === 'codigoProva') ? filters.find(f => f.field === 'codigoProva').value : "",
                nome: filters.find(f => f.field === 'nome') ? filters.find(f => f.field === 'nome').value : "",
                nomeSoberano: filters.find(f => f.field === 'nomeSoberano') ? filters.find(f => f.field === 'nomeSoberano').value : "",
                email: filters.find(f => f.field === 'email') ? filters.find(f => f.field === 'email').value : "",
                cpf: filters.find(f => f.field === 'cpf') ? filters.find(f => f.field === 'cpf').value : "",
                sexo: filters.find(f => f.field === 'sexo') ? filters.find(f => f.field === 'sexo').value : "",
                necessidadeEspecial: filters.find(f => f.field === 'necessidadeEspecial') ? filters.find(f => f.field === 'necessidadeEspecial').value : "",
                sabatista: filters.find(f => f.field === 'sabatista') ? filters.find(f => f.field === 'sabatista').value : "",
                comEscolaSelecionada: filters.find(f => f.field === 'comEscolaSelecionada') ? filters.find(f => f.field === 'comEscolaSelecionada').value : "",
                status: filters.find(f => f.field === 'status') ? filters.find(f => f.field === 'status').value : "",
                dataInicioInscricao: filters.find(f => f.field === 'dataInicioInscricao') ? filters.find(f => f.field === 'dataInicioInscricao').value : "",
                dataFinalizacaoInscricao: filters.find(f => f.field === 'dataFinalizacaoInscricao') ? filters.find(f => f.field === 'dataFinalizacaoInscricao').value : "",
                candidaturaFinalizada: filters.find(f => f.field === 'candidaturaFinalizada') ? filters.find(f => f.field === 'candidaturaFinalizada').value : "",
                candidaturaReaberta: filters.find(f => f.field === 'candidaturaReaberta') ? filters.find(f => f.field === 'candidaturaReaberta').value : "",
                statusDocumento: filters.find(f => f.field === 'statusDocumento') ? filters.find(f => f.field === 'statusDocumento').value : "",
                comLocalProvaSelecionado: filters.find(f => f.field === 'comLocalProvaSelecionado') ? filters.find(f => f.field === 'comLocalProvaSelecionado').value : "",
                dataConfirmacaoLocalProva: filters.find(f => f.field === 'dataConfirmacaoLocalProva') ? filters.find(f => f.field === 'dataConfirmacaoLocalProva').value : "",
            },
            count: filters.reduce((total, f) => f.value !== '' ? total + 1 : total, 0),
        })

        this.Escola.setState({
            filters: {
                nameSchool: filters.find(f => f.field === 'nomeEscola') ? filters.find(f => f.field === 'nomeEscola').value : "",
                inepSchool: filters.find(f => f.field === 'inep') ? filters.find(f => f.field === 'inep').value : "",
            }
        })

        this.DependenciaAdministrativa.setState({
            filters: {
                adminDep: filters.find(f => f.field === 'dependenciaAdministrativa') ? filters.find(f => f.field === 'dependenciaAdministrativa').value : "",
            }
        })

        this.EscolaEndereco.setState({
            filters: {
                UF: filters.find(f => f.field === 'ufEscola') ? filters.find(f => f.field === 'ufEscola').value : "",
                region: filters.find(f => f.field === 'regiaoEscola') ? filters.find(f => f.field === 'regiaoEscola').value : "",
                city: filters.find(f => f.field === 'municipioEscola') ? filters.find(f => f.field === 'municipioEscola').value : "",
            }
        }, () => this.EscolaEndereco.findCities(true))

        this.Endereco.setState({
            filters: {
                UF: filters.find(f => f.field === 'uf') ? filters.find(f => f.field === 'uf').value : "",
                region: filters.find(f => f.field === 'regiao') ? filters.find(f => f.field === 'regiao').value : "",
                city: filters.find(f => f.field === 'municipio') ? filters.find(f => f.field === 'municipio').value : "",
            }
        }, () => this.Endereco.findCities(true))

        this.LocalProvaOriginal.setState({
            filters: {
                ufProva: filters.find(f => f.field === 'ufProvaOriginal') ? filters.find(f => f.field === 'ufProvaOriginal').value : "",
                regiaoProva: filters.find(f => f.field === 'regiaoProvaOriginal') ? filters.find(f => f.field === 'regiaoProvaOriginal').value : "",
                municipioProva: filters.find(f => f.field === 'municipioProvaOriginal') ? filters.find(f => f.field === 'municipioProvaOriginal').value : "",
            }
        }, () => this.LocalProvaOriginal.findCities(true))

        this.LocalProvaConfirmado.setState({
            filters: {
                ufProva: filters.find(f => f.field === 'ufProvaConfirmado') ? filters.find(f => f.field === 'ufProvaConfirmado').value : "",
                regiaoProva: filters.find(f => f.field === 'regiaoProvaConfirmado') ? filters.find(f => f.field === 'regiaoProvaConfirmado').value : "",
                municipioProva: filters.find(f => f.field === 'municipioProvaConfirmado') ? filters.find(f => f.field === 'municipioProvaConfirmado').value : "",
            }
        }, () => this.LocalProvaConfirmado.findCities(true))
    }

    // FILTROS
    handleFilterApply = () => {
        const f = [];
        const { filters, exportPlan, exportarPlanLocalProva } = this.state;
        const filtersDepAdmin = this.DependenciaAdministrativa.state.filters;
        const filtersEscola = this.Escola.state.filters;

        if (filters.codigo) f.push({ field: 'codigo', value: filters.codigo })
        if (filters.codigoProva) f.push({ field: 'codigoProva', value: filters.codigoProva })        
        if (filters.nome) f.push({ field: 'nome', value: filters.nome })
        if (filters.nomeSoberano) f.push({ field: 'nomeSoberano', value: filters.nomeSoberano })
        if (filters.email) f.push({ field: 'email', value: filters.email })
        if (filters.cpf) f.push({ field: 'cpf', value: filters.cpf })
        if (filters.sexo) f.push({ field: 'sexo', value: filters.sexo })
        if (filters.necessidadeEspecial) f.push({ field: 'necessidadeEspecial', value: filters.necessidadeEspecial })
        if (filters.sabatista) f.push({ field: 'sabatista', value: filters.sabatista })
        if (filters.comEscolaSelecionada) f.push({ field: 'comEscolaSelecionada', value: filters.comEscolaSelecionada })
        if (filters.status) f.push({ field: 'status', value: filters.status })
        if (filters.dataInicioInscricao) f.push({ field: 'dataInicioInscricao', value: filters.dataInicioInscricao })
        if (filters.dataFinalizacaoInscricao) f.push({ field: 'dataFinalizacaoInscricao', value: filters.dataFinalizacaoInscricao })
        if (filters.candidaturaFinalizada) f.push({ field: 'candidaturaFinalizada', value: filters.candidaturaFinalizada })
        if (filters.candidaturaReaberta) f.push({ field: 'candidaturaReaberta', value: filters.candidaturaReaberta })
        if (filters.statusDocumento) f.push({ field: 'statusDocumento', value: filters.statusDocumento })
        if (filters.comLocalProvaSelecionado) f.push({ field: 'comLocalProvaSelecionado', value: filters.comLocalProvaSelecionado })
        if (filters.dataConfirmacaoLocalProva) f.push({ field: 'dataConfirmacaoLocalProva', value: filters.dataConfirmacaoLocalProva })

        if (filtersDepAdmin.adminDep) f.push({ field: 'dependenciaAdministrativa', value: filtersDepAdmin.adminDep })

        if (filtersEscola.nameSchool) f.push({ field: 'nomeEscola', value: filtersEscola.nameSchool })
        if (filtersEscola.inepSchool) f.push({ field: 'inep', value: filtersEscola.inepSchool })

        const filtersEscolaEndereco = this.EscolaEndereco.state.filters;
        if (filtersEscolaEndereco.UF) f.push({ field: 'ufEscola', value: filtersEscolaEndereco.UF })
        if (filtersEscolaEndereco.region) f.push({ field: 'regiaoEscola', value: filtersEscolaEndereco.region })
        if (filtersEscolaEndereco.city) f.push({ field: 'municipioEscola', value: filtersEscolaEndereco.city })

        const filtersEndereco = this.Endereco.state.filters;
        if (filtersEndereco.UF) f.push({ field: 'uf', value: filtersEndereco.UF })
        if (filtersEndereco.region) f.push({ field: 'regiao', value: filtersEndereco.region })
        if (filtersEndereco.city) f.push({ field: 'municipio', value: filtersEndereco.city })

        const filtersLocalProvaOriginal = this.LocalProvaOriginal.state.filters;
        if (filtersLocalProvaOriginal.ufProva) f.push({ field: 'ufProvaOriginal', value: filtersLocalProvaOriginal.ufProva })
        if (filtersLocalProvaOriginal.regiaoProva) f.push({ field: 'regiaoProvaOriginal', value: filtersLocalProvaOriginal.regiaoProva })
        if (filtersLocalProvaOriginal.municipioProva) f.push({ field: 'municipioProvaOriginal', value: filtersLocalProvaOriginal.municipioProva })

        const filtersLocalProvaConfirmado = this.LocalProvaConfirmado.state.filters;
        if (filtersLocalProvaConfirmado.ufProva) f.push({ field: 'ufProvaConfirmado', value: filtersLocalProvaConfirmado.ufProva })
        if (filtersLocalProvaConfirmado.regiaoProva) f.push({ field: 'regiaoProvaConfirmado', value: filtersLocalProvaConfirmado.regiaoProva })
        if (filtersLocalProvaConfirmado.municipioProva) f.push({ field: 'municipioProvaConfirmado', value: filtersLocalProvaConfirmado.municipioProva })


        if (exportPlan) {
            f.push({ field: 'exportarPlanilha', value: exportPlan });

            CandidatoService.export(f)
                .then(res => download(res))
                .finally(() => this.setState({ exportPlan: false }))
        } if(exportarPlanLocalProva) {

            const filteredF = f.filter(item => item.field !== 'status');

            filteredF.push({ field: 'exportarPlanilhaLocalProva', value: exportarPlanLocalProva });
            filteredF.push({ field: 'status', value: "FINALIZADO" });

            CandidatoService.export(filteredF)
                .then(res => download(res))
                .finally(() => this.setState({ exportarPlanLocalProva: false }))        
        } else {
            this.props.handleFilterChange(f);
        }
    }

    // LIMPAR FILTROS
    handleFilterClear = () => {
        this.setState({
            ...this.state,
            filters: {
                codigo: '',
                nome: '',
                nomeSoberano: '',
                email: '',
                cpf: '',
                sexo: '',
                necessidadeEspecial: '',
                sabatista: '',
                comEscolaSelecionada: '',
                status: '',
                dataInicioInscricao: '',
                dataFinalizacaoInscricao: '',
                candidaturaFinalizada: '',
                candidaturaReaberta: '',
                statusDocumento: '',
                comLocalProvaSelecionado: '',
                dataConfirmacaoLocalProva: '',
            },
            exportPlan: false,
            exportarPlanLocalProva: false,
            count: 0,
        })

        this.DependenciaAdministrativa.setState({
            filters: {
                adminDep: '',
            }
        })

        this.Escola.setState({
            filters: {
                nameSchool: '',
                inepSchool: '',
            }
        })

        this.EscolaEndereco.limparBuscas();

        this.Endereco.limparBuscas();

        this.LocalProvaOriginal.limparBuscas();

        this.LocalProvaConfirmado.limparBuscas();

        this.props.handleFilterChange([], false);
    }

    // CONTAGEM DE FILTROS ATIVOS
    handleCountFilters = () => this.state.count;

    async componentDidMount() {
        const statusCandidato = await EnumService.listarStatusCandidato().then(res => res.data);
        const sexos = await EnumService.listarSexos().then(res => res.data);
        const racas = await EnumService.listarRacas().then(res => res.data);
        const necessidadesEspeciais = await EnumService.listarNecessidadesEspeciais().then(res => res.data);
        const statusDocumento = await EnumService.listarStatusValidacao().then(res => res.data);

        this.setState({
            optionsStatusCandidato: [...this.state.optionsStatusCandidato, ...statusCandidato],
            optionsSexo: [...sexos],
            optionsRaca: [...racas],
            optionsNecessidadesEspecial: [...necessidadesEspeciais],
            optionsStatusDocumento: [...statusDocumento]
        });
    }

    render() {
        return (
            <Filters
                handleFilter={this.handleFilterApply}
                handleFilterClear={this.handleFilterClear}
                countFilters={this.handleCountFilters}
            >
                <Categoria nome="Dados Gerais" icone={<SupervisorAccountIcon />}>
                    <Grid container spacing={3}>

                        <Grid item sm={12} lg={3}>
                            <Text
                                label="Nome"
                                name='nome'
                                value={this.state.filters.nome}
                                onChange={(e) => this.handleChange(e)}
                            />
                        </Grid>

                        <Grid item sm={12} lg={3}>
                            <Text
                                label="Nome Social"
                                name='nomeSoberano'
                                value={this.state.filters.nomeSoberano}
                                onChange={(e) => this.handleChange(e)}
                            />
                        </Grid>

                        <Grid item sm={12} lg={1}>
                            <Text
                                label="CPF"
                                name='cpf'
                                value={this.state.filters.cpf}
                                onChange={(e) => this.handleChange(e)}
                            />
                        </Grid>

                        <Grid item sm={12} lg={1}>
                            <SelectOption
                                label="Sexo"
                                name='sexo'
                                value={this.state.filters.sexo}
                                onChange={(e) => this.handleChange(e)}
                                options={this.state.optionsSexo}
                            />
                        </Grid>

                        <Grid item sm={12} lg={3}>
                            <SelectOption
                                label="Deficiência"
                                name='necessidadeEspecial'
                                value={this.state.filters.necessidadeEspecial}
                                onChange={(e) => this.handleChange(e)}
                                options={this.state.optionsNecessidadesEspecial}
                            />
                        </Grid>

                        <Grid item sm={12} lg={1}>
                            <Boolean
                                label="Sabatista"
                                name='sabatista'
                                value={this.state.filters.sabatista}
                                onChange={(e) => this.handleChange(e)}
                            />
                        </Grid>

                        <Grid item sm={12} lg={3}>
                            <Text
                                label="E-mail"
                                name='email'
                                value={this.state.filters.email}
                                onChange={(e) => this.handleChange(e)}
                            />
                        </Grid>

                        <Grid item container spacing={3}>
                            <Endereco
                                parentRef={this.setEndereco}
                                withRegion={true}
                                habilitarFiltroCR={true}
                            />
                        </Grid>
                    </Grid>
                </Categoria>

                <Categoria nome="Dados de Escola de Atuação" icone={<SchoolOutlinedIcon />}>
                    <Grid container spacing={3}>
                        <Grid item sm={12} lg={4}>
                            <Boolean
                                label="Com Escola Selecionada?"
                                name='comEscolaSelecionada'
                                value={this.state.filters.comEscolaSelecionada}
                                onChange={(e) => this.handleChange(e)}
                            />
                        </Grid>
                        
                        <Grid item container spacing={3}>
                            <Escola
                                parentRef={this.setEscola}
                                disabledEmail={true}
                            />

                            <Grid item sm={12} lg={1}></Grid>

                            <DependenciaAdministrativa
                                parentRef={this.setDependenciaAdministrativa}
                                withPublicGroup={true}
                                withSemEscolaInformada={true}
                            />
                        </Grid>

                        <Grid item container spacing={4}>
                            <EscolaEndereco
                                parentRef={this.setEscolaEndereco}
                                withRegion={true}
                                habilitarFiltroCR={true}
                            />
                        </Grid>
                    </Grid>
                </Categoria>

                <Categoria nome="Dados de Inscrição" icone={<DescriptionIcon />}>
                    <Grid container spacing={3}>
                        <Grid item container spacing={3}>

                            <Grid item sm={12} lg={2}>
                                <Text
                                    label="Código"
                                    name='codigo'
                                    value={this.state.filters.codigo}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>

                            <Grid item sm={12} lg={2}>
                                <Text
                                    label="Código de Prova"
                                    name='codigoProva'
                                    value={this.state.filters.codigoProva}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>

                            <Grid item sm={12} lg={2}>
                                <Text
                                    maxLength='10'
                                    label="Data de Início da Inscrição"
                                    name='dataInicioInscricao'
                                    value={this.state.filters.dataInicioInscricao}
                                    onChange={this.handleChange}
                                    helperText="dd/mm/yyyy"
                                />
                            </Grid>

                            <Grid item sm={12} lg={2}>
                                <Text
                                    maxLength='10'
                                    label="Data de Finalização da Inscrição"
                                    name='dataFinalizacaoInscricao'
                                    value={this.state.filters.dataFinalizacaoInscricao}
                                    onChange={this.handleChange}
                                    helperText="dd/mm/yyyy"
                                />
                            </Grid>

                            <Grid item sm={12} lg={1}></Grid>

                            <Grid item sm={12} lg={2}>
                                <SelectOption
                                    label="Status de Candidato"
                                    name='status'
                                    value={this.state.filters.status}
                                    onChange={(e) => this.handleChange(e)}
                                    options={this.state.optionsStatusCandidato}
                                />
                            </Grid>

                            <Grid item sm={12} lg={2}>
                                <SelectOption
                                    label="Status Documento"
                                    name='statusDocumento'
                                    value={this.state.filters.statusDocumento}
                                    options={this.state.optionsStatusDocumento}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>

                            <Grid item sm={12} lg={1}></Grid>
                            {/*
                            <Grid item sm={12} lg={2}>
                                <Boolean
                                    label="Inscrição Finalizada?"
                                    name='candidaturaFinalizada'
                                    value={this.state.filters.candidaturaFinalizada}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>

                            <Grid item sm={12} lg={2}>
                                <Boolean
                                    label="Inscrição Reaberta?"
                                    name='candidaturaReaberta'
                                    value={this.state.filters.finalizouLancamentoNotas}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>*/}
                        </Grid>
                    </Grid>
                </Categoria>

                <Categoria nome="Local de Realização da Prova" icone={<LocationOnIcon />}>
                    <Grid container spacing={3}>
                        <Grid item container spacing={3}>
                            <Grid item sm={12} lg={4}>
                                <Boolean
                                    label="Com Local de Prova Selecionado?"
                                    name='comLocalProvaSelecionado'
                                    value={this.state.filters.comLocalProvaSelecionado}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>
                        </Grid>

                        <Grid item container spacing={4}>
                            <LocalProva
                                parentRef={this.setLocalProvaOriginal}
                                labelSufix="Original"
                                habilitarFiltroCR={true}
                            />
                        </Grid>

                        <Grid item sm={12} lg={1}></Grid>

                        <Grid item container spacing={4}>
                            <LocalProva
                                parentRef={this.setLocalProvaConfirmado}
                                labelSufix="Confirmado"
                                disabledFiltroCR={true}
                            />
                            <Grid item sm={12} lg={3}>
                                <Text
                                    maxLength='10'
                                    label="Data da Confirmação do Local da Prova"
                                    name='dataConfirmacaoLocalProva'
                                    value={this.state.filters.dataConfirmacaoLocalProva}
                                    onChange={this.handleChange}
                                    helperText="dd/mm/yyyy"
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Categoria>
            </Filters>
        )
    }
}

export default CandidatoFilter;